import React from 'react';

import Fade from '@material-ui/core/Fade';
import settings from 'settings';

// 本番環境では Fade コンポーネントをエクスポートしています。
// テスト用にアニメーションはカットしています。
export default (props) => 
  settings.enablePageAnimation ? <Fade timeout={600} {...props} /> : <React.Fragment children={props.children} />;